<template>
  <div class="outer"
       ref='outer'
       @mousedown.self.prevent="onHold"
       @touchstart.self.prevent="onHold"
       @mouseup.self.prevent="leave"
       @touchend.self.prevent="leave">
    <div class="wrapper">

      <transition name="cover">
        <div v-show="showCover" class="cover">
          <h1>{{title.en}}</h1>
          <div class="begin-btn" @click="ask">[Ask Question]</div>
        </div>
      </transition>

      <transition name="intro">
        <div v-show="showIntro" class="intro-wrap">
          <pre class="intro" @click="introLeave">{{intro}}</pre>
        </div>
      </transition>

      <transition name="cd">
        <div class="countdown-wrap" v-show="showCountdown">
          <h1>{{countdownNo}}</h1>
          <pre class="countdown">{{countdownTxt}}</pre>
          <div class="gray-btn" :class="{show:showReveal}" @click="clickReveal">Click to reveal</div>
        </div>
      </transition>

      <transition name="answer">
        <div class="answer-wrap" v-show="showAnswer">
          <h1>{{answer}}</h1>
          <div class="gray-btn" :class="{show:showAskAgain}" @click="askAgain">Ask one more</div>
        </div>
      </transition>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import './answer.styl'
export default {
  name: 'BOA',
  data () {
    return {
      title: {en: 'Book Of Answers', ch: '解 答 之 书'},
      h1: 'Book Of Answers',
      showCover: false,
      intro: 'Here you have a question that wish to ask \n [It’s for serious one, not for fun] \n \n Close your eyes \n and meditate for several seconds \n Click anywhere on the screen whenever you are ready \n the Book will answer that for you \n it may take couple of seconds',
      showIntro: false,
      countdownScript: [
        '[Here is the one the Book gives you,\n are you ready?]',
        '[And you know the answer,\n by heart]',
        '[All questions could be answered some day,\n it’s just a matter of time]'
      ],
      countdownNo: 3,
      countdownTxt: '[All questions could be answered some day,\n it’s just a matter of time]',
      showCountdown: false,
      showReveal: false,
      answer: '',
      answerLang: undefined,
      showAnswer: false,
      showAskAgain: false
    }
  },
  methods: {
    getAnswer () {
      axios.get('assets/pages/answers/answers.txt')
        .then(rawFile => {
          let allText = rawFile ? rawFile.data : 'No answer for that'
          let answers = allText.split('\n')
          let index = Math.round(Math.random() * answers.length)
          return {txt: answers[index], index}
        })
        .then(answersEn => {
          axios.get('assets/pages/answers/answers_ch.txt')
            .then(rawFile => {
              let allText = rawFile ? rawFile.data : '没有答案'
              let answers = allText.split('\n')
              this.h1 = answersEn.txt
              let txt = {
                en: answersEn.txt,
                ch: answers[answersEn.index]
              }
              this.answer = txt.en
              this.answerLang = txt
              console.log(txt)
              return txt
            })
        })
    },
    ask () {
      this.showCover = false
      setTimeout(() => { this.showIntro = true }, 1300)
      this.getAnswer()
    },
    introLeave () {
      this.showIntro = false

      let nextTxt = () => {
        this.countdownNo -= 1
        this.countdownTxt = this.countdownScript[this.countdownNo - 1]
      }

      setTimeout(() => {
        this.scriptEnter()
          .then(() => { return this.scriptEnter(false) })
          .then(() => {
            nextTxt()
            return this.scriptEnter()
          })
          .then(() => { return this.scriptEnter(false) })
          .then(() => {
            nextTxt()
            return this.scriptEnter()
          })
          .then(() => {
            this.showReveal = true
          })
      }, 900)
    },
    scriptEnter (isEnter = true) {
      return new Promise(resolve => {
        this.showCountdown = isEnter
        let outerDom = this.$refs.outer
        let onClick = ()=>{
          resolve()
          outerDom.removeEventListener('click', onClick)
        }
        outerDom.addEventListener( 'click', onClick )
        setTimeout(() => {
          resolve()
          outerDom.removeEventListener('click', onClick )
        }, isEnter ? 4200 : 1500)
      })
    },
    clickReveal () {
      if (!this.showReveal) return
      this.showCountdown = false
      setTimeout(() => {
        this.showAnswer = true
        setTimeout(() => {
          this.showAskAgain = true
        }, 3000)
      }, 1500)
    },
    askAgain () {
      if (!this.showAskAgain) return
      this.countdownNo = this.countdownScript.length
      this.countdownTxt = this.countdownScript[this.countdownNo - 1]
      this.showReveal = false
      this.showAskAgain = false
      this.showAnswer = false
      setTimeout(() => { this.showCover = true }, 2000)
    },
    onHold (isHold = true) {
      if (!(this.answerLang || this.showAnswer)) return
      this.answer = isHold ? this.answerLang.ch : this.answerLang.en
    },
    leave () { this.onHold(false) }
  },
  mounted () {
    this.showCover = true
  }
}
</script>
